import React from "react";
import "./DisclaimerBanner.css";
import { useTranslation } from "react-i18next";

const DisclaimerBanner = () => {
  const { t } = useTranslation();

  return <div className="disclaimer-banner">{t("app.legal.disclaimer")}</div>;
};

export default DisclaimerBanner;
